import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { MovimentacaoProduto } from '../../types/estoque';
import { movimentacoesService } from '../../services';

const transferService = {
  ...movimentacoesService,
  list: (params?: any) =>
    movimentacoesService.list({ 
      page_size: 25,
      ...(params || {}), 
      tipo_movimento: 'TRANSFERENCIA',
    }),
};

const columns: ResourceColumn<MovimentacaoProduto>[] = [
  { header: 'Data/Hora', accessor: 'data_hora' },
  {
    header: 'Estoque',
    render: (item) =>
      (item as any).estoque_info ?? (item as any).produto_nome ?? item.estoque ?? '-',
  },
  { header: 'Quantidade', accessor: 'quantidade' },
  { header: 'Origem (armazém)', accessor: 'origem' },
  { header: 'Destino (armazém)', accessor: 'destino' },
  { header: 'Operador', accessor: 'operador' },
];

export const MovimentacoesProdutosListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Transferências de estoque"
    description="Histórico de transferências entre armazéns."
    columns={columns}
    service={transferService as any}
    createPath="/admin/movimento/transferencias-estoque/novo"
      onEdit={(item) => item.id && navigate("/admin/movimento/transferencias-estoque/editar", { state: { record: item } })}
    searchPlaceholder="Buscar por origem/destino/operador..."
  />
  );
};
